<template>
  <div v-if="hasVariants" @click="toggleDropdown" :class="[dropdownCss]">
    <ul data-test="product-variant-dropdown">
      <li class="selected">{{ dropdownTitle }}</li>
      <li v-for="variant in variants"
          :key="variant.id"
          class="variant-dropdown"
          @click.stop="setSelected(variant)">
        {{ variant.title }}
        <span v-if="!isAvailable(variant)">(Out of stock)</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "VariantDropdown",
  props: {
    variants: {
      type: Array,
      default: () => []
    },
    variantStock: {
      type: Array,
      default: () => []
    },
    selectedVariant: {
      type: Object,
      default: () => ({})
    },
    hasVariants: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dropdownTitle: "Choose An Option",
      isActive: false
    }
  },
  watch: {
    selectedVariant: {
      deep: true,
      immediate: true,
      handler(newVariant) {
        this.setTitleFromVariant(newVariant);
      }
    }
  },
  computed: {
    dropdownCss() {
      const icon = this.isActive ? "zmdi-chevron-up" : "zmdi-chevron-down"
      return `variant-dropdown variant-dropdown--${this.isActive ? "active" : "inactive"} zmdi ${icon}`
    },
    availabilityMap() {
      const map = {}
      for (const item of this.variantStock || []) {
        const id = item.id || (item.node && item.node.id)
        if (!id) continue
        const availableForSale = typeof item.availableForSale === "boolean" ? item.availableForSale : !!(item.node && item.node.availableForSale)
        const quantityAvailable = typeof item.quantityAvailable === "number" ? item.quantityAvailable : (item.node && item.node.quantityAvailable)
        map[id] = { availableForSale, quantityAvailable }
      }
      return map
    }
  },
  methods: {
    toggleDropdown() {
      this.isActive = !this.isActive
    },
    isAvailable(variant) {
      const rec = this.availabilityMap[variant.id]
      if (!rec) {
        if (typeof variant.availableForSale === "boolean") {
          return variant.availableForSale
        }
        return false
      }
      if (typeof rec.quantityAvailable === "number") return rec.availableForSale && rec.quantityAvailable > 0
      return !!rec.availableForSale
    },
    setTitleFromVariant(variant) {
      if (!variant || !variant.id) {
        return false
      }
      const available = this.isAvailable(variant)
      window.ossEngraverImage = window.ossEngraverImage || {}
      window.ossEngraverImage.id = variant.id
      this.dropdownTitle = variant.title + (available ? "" : " (Out of stock)")
      return true
    },
    emitSelection(variant) {
      this.$emit("variant-selected", variant)
    },
    setSelected(variant) {
      this.setTitleFromVariant(variant)
      this.emitSelection(variant)
      this.isActive = false
    },
    setFirstAvailableVariant() {
      const firstAvailable = this.variants.find(v => this.isAvailable(v))
      if (firstAvailable) {
        this.setTitleFromVariant(firstAvailable)
        this.emitSelection(firstAvailable)
      }
    }
  },
  mounted() {
    if (!this.setTitleFromVariant(this.selectedVariant)) {
      this.setFirstAvailableVariant()
    }
  }
}
</script>
